<script setup lang="ts">
const { data: artworks } = useFetch<Artwork[]>("/api/artworks");
const { data: categories } = await useFetch<ArtworkCategory[]>("/api/artwork-categories");

useHead({
  title: "Home",
});

onMounted(() => {

});

</script>
<template>
  <Slider />

  <div class="content">
    <IndexArtworksGrid  style="padding-top: 4rem;" :artworks="artworks!" :categories="categories!" />
  </div>
</template>
